module.exports = __webpack_public_path__ + "img/armor.927facf5.png";